import React from 'react';
import { getWhitelabel } from 'web-app/shared/white-labeling-helpers';
import { buildConfiguration } from './build-config';
// Cache the configuration since whitelabel doesn't change during a session
let cachedConfig = null;
/**
 * Hook to get the whitelabel configuration for the current domain.
 * Replaces the Redux-based WhitelabelSelectors.whiteLabelConfiguration.
 *
 * The whitelabel is determined by domain matching at app initialization,
 * so the configuration is cached and returned consistently.
 *
 * @returns The WhiteLabelConfiguration for the current whitelabel
 *
 * @example
 * const Component = () => {
 *   const whitelabelConfiguration = useWhitelabelConfiguration();
 *   return <Text>{whitelabelConfiguration.ProductName}</Text>;
 * };
 */
export const useWhitelabelConfiguration = () => {
    return React.useMemo(() => {
        if (cachedConfig) {
            return cachedConfig;
        }
        const whitelabel = getWhitelabel();
        cachedConfig = buildConfiguration(whitelabel);
        return cachedConfig;
    }, []);
};
